import React, { Suspense, createContext, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ls from 'local-storage';
import './scss/style.scss';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Authentication from './utils/auth/Authentication';

export const Loading = () => { 
    return (
        <div className="pt-3 text-center">
            <div className="sk-spinner sk-spinner-pulse"></div>
        </div>
    ) 
};

// Contexts
export const AuthContext = createContext(new Authentication());

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

const ReloginGuard = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isLoginPage = location.pathname === '/login';
    const isReloggedIn = ls.get('relogged_in') === 1 || ls.get('relogged_in') === '1';

    useEffect(() => {
        if (!isLoginPage && !(ls.get('relogged_in') === 1 || ls.get('relogged_in') === '1')) {
            ls.clear();
            navigate('/login', { replace: true });
        }
    }, [location.pathname, isLoginPage, navigate]);

    if (!isLoginPage && !isReloggedIn) {
        ls.clear();
        return <Navigate to="/login" replace />;
    }

    return children;
};

const App = () => {
    // const [Auth, _] = useState(new Authentication())
    const [Auth, setAuth] = useState(new Authentication())
    const [fetched, setFetched] = useState(false)
    useEffect(() => {
        if (window.location.pathname !== '/login' && !(ls.get('relogged_in') === 1 || ls.get('relogged_in') === '1')) {
            ls.clear();
            setFetched(false);
            return;
        }
        if (Auth.isEmpty() && localStorage.getItem('userDetail')){
            var tmp = new Authentication()
            tmp.fetchPermissions().then(() => {
                setAuth(tmp)
                setFetched(true)
            })
        } else {
            setFetched(false)
        }
    }, [])

    // useEffect(() => {
    //     console.log("changed")
    // }, [Auth])
    return (
        <BrowserRouter>
            <Suspense fallback={Loading}>
                <AuthContext.Provider value={Auth}>
                    <ReloginGuard>
                        <Routes>
                            <Route exact path="/login" name="Login Page" element={<Login />} />
                            {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
                            <Route path="/*" name="Home" element={<DefaultLayout />} />
                            <Route exact path="/404" name="Page 404" element={<Page404 />} />
                            <Route exact path="/500" name="Page 500" element={<Page500 />} />
                            {/* <Route path="/" name="Login" element={<Login />} /> */}
                        </Routes>
                    </ReloginGuard>
                </AuthContext.Provider>
            </Suspense>
        </BrowserRouter>
    );
}

export default App;
